import {DateFormats} from "@/scripts/Common/DateFormats";
import moment from "moment";

const getSepaAccountingPeriod = (accountingStartDate: string, accountingEndDate: string) => {
  if (accountingStartDate === accountingEndDate) {
    return `${moment(accountingStartDate).format(DateFormats.YEAR_MONTH_DAY)}`
  }

  return `${moment(accountingStartDate).format(DateFormats.YEAR_MONTH_DAY)}-${moment(accountingEndDate).format(DateFormats.YEAR_MONTH_DAY)}`
}


export {
  getSepaAccountingPeriod
}
